import React from 'react'

import Section from 'component/Section'
import SectionSplit from 'component/SectionSplit'
import SectionSplitWrapper from 'component/SectionSplitWrapper'

import DescriptionList from 'component/DescriptionList'
import IconChatBubble from 'svg/icons/chat-bubble.svg'
import IconChatBubbleAurum from 'svg/icons/chat-bubble-aurum.svg'

const ContentSection = () => {
	return (
		<Section theme="content">
			<SectionSplitWrapper>
				<SectionSplit>
					<DescriptionList
						titleIcon={<IconChatBubble />}
						suptitle={'Portal da Aurum'}
						title={'Artigos e novidades'}
						links={[
							{
								id: 1,
								href: '/blog/melhor-software-juridico-do-mercado/',
								text:
									'Como escolher o melhor software jurídico para o seu escritório',
							},
							{
								id: 2,
								href: '/blog/gestao-de-processos-judiciais/',
								text: 'Gerenciamento de processos judiciais com o Astrea',
							},
							{
								id: 3,
								href: '/blog/themis-para-departamento-juridico/',
								text:
									'Veja como o Themis pode auxiliar departamentos jurídicos',
							},
						]}
					/>
				</SectionSplit>
				<SectionSplit>
					<DescriptionList
						titleIcon={<IconChatBubbleAurum />}
						suptitle={'Materiais Educativos'}
						title={'Conteúdo exclusivo'}
						links={[
							{
								id: 1,
								href:
									'https://www.aurum.com.br/blog/material/autoridade-na-advocacia/',
								text:
									'[eBook] Construção de autoridade na advocacia através do Instagram',
								target: 'blank',
							},
							{
								id: 2,
								href:
									'https://www.aurum.com.br/blog/material/guia-boas-praticas-lgpd/',
								text: '[eBook] Guia de boas práticas da LGPD',
								target: 'blank',
							},
							{
								id: 3,
								href:
									'https://www.aurum.com.br/blog/material/ebook-guia-de-pecas-juridicas/',
								text:
									'[eBook] Guia de peças jurídicas para advogados iniciantes',
								target: 'blank',
							},
						]}
					/>
				</SectionSplit>
			</SectionSplitWrapper>
		</Section>
	)
}

export default ContentSection
